<template>
    <div class="container">
        <div class="main">
            <div v-if="isWechat" class="wechat-show">
                <img  style="width: 100%;height: 100%" src="../assets/wechat-open.jpeg">
            </div>
            <div v-else-if="token === undefined || token === '' || invalid">
                <p style="color:darkred">链接已失效</p>
            </div>
            <div v-else class="block">
                <div class="tips">请输入提取密码：</div>
                <div class="getBox">
                    <div class="input-group">
                        <input class="input" v-model="password" type="text">
                        <div class="input-btn">
                            <button class="btn" v-on:click="getUrl">确定</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDownUrl} from "../api/gameDown";

    export default {
        name: "index",
        data() {
            return {
                password: "",
                invalid: false,
            }
        },
        computed: {
          token() {
            return this.$route.query.token
          },
          isWechat(){
            return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
          }

        },
        methods: {
            getUrl() {
                getDownUrl(this.token, this.password)
                    .then((res) => {
                        //跳转1
                        window.location.href = res.data.url
                    })
                    .catch(() => {
                        this.invalid = true
                    });
            },
        }
    }
</script>

<style scoped>
    .container {
        background: #eef2f6; /* fallback for old browsers */
        position: relative;
    }
    .main {
        height: 100vh;
        display: -webkit-flex;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('~@/./assets/down-bg.png') bottom repeat-x;
        background-size:auto 300px;
    }

    .wechat-show{
      width: 100%;
      height: 100%;
    }

    .block {
        width: 90%;
        max-width:460px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 0 10px rgb(171 198 235 / 30%);
        box-sizing: border-box;
    }
    .tips{font-size:14px;
        padding:15px 30px;
        color: #fff;
        line-height: 1.5;
        text-align: left;
    font-weight:bold;
        background: #00B4DB;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to top, #0083B0, #00B4DB);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to top, #0083B0, #00B4DB); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    .getBox{
        padding:48px 30px;
    }
    .input-group{
        position: relative;
        display: table;
        border-collapse: separate;
    }
    .input{
        border: 1px solid #f2f2f2;
        padding: 8px 10px;
        height: 34px;
        line-height: 1.42857143;
        border-radius: 4px;
        color: #666;font-size:12px;
        display: table-cell;
        position: relative;
        z-index: 2;
        float: left;
        width: 100%;
        vertical-align: middle;
        box-sizing: border-box;
    }
    .input:hover,.input:focus{border-color:#00B4DB;}
    .input-btn{
        width: 1%;
        white-space: nowrap;
        vertical-align: middle;
        display: table-cell;
    }
    .btn{
        display: inline-block;
        font-size: 14px;
        border: 1px solid #0083B0;
        background: #0083B0;
        white-space: nowrap;
        padding: 6px 12px;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        line-height: 1.42857143;
        border-radius: 4px;
        color:#fff;
    }

</style>